import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import {
	toggleCollapseDashboardNav,
	selectHasDashboardNav,
} from 'reducers/uiStateReducer';
import AccountDropdown from 'components/appHeader/AccountDropdown';
import HeaderSearch from 'components/appHeader/HeaderSearch';
import { ReactComponent as MenuIcon } from 'assets/icons/menu.svg';
import { ReactComponent as ShoppingCartIcon } from 'assets/icons/shopping-cart.svg';

import './AppHeader.css';

const CartLink = ({ cartCount }) => {
	return (
		<span className="tw-relative">
			<Link
				to="/cart"
				aria-label="Cart"
				className="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-text-icon-primary hover:tw-bg-surface-layer-02 hover:tw-text-icon-primary"
			>
				<ShoppingCartIcon className="tw-h-4 tw-w-4" aria-hidden="true" />
			</Link>
			{cartCount > 0 && (
				<span className="-tw-top-1 -tw-right-1 tw-absolute tw-flex tw-h-4 tw-min-w-[16px] tw-items-center tw-justify-center tw-rounded-full tw-bg-icon-error tw-px-1 tw-text-[10px] tw-font-bold tw-text-surface-background">
					{cartCount}
				</span>
			)}
		</span>
	);
};

const AppHeader = (props) => {
	const hideHeaderSearch = props.hideHeaderSearch;
	const dispatch = useDispatch();
	const { cartCount, hasDashboardNav } = useSelector((state) => ({
		cartCount: state.cart.items.length,
		// Only pages built on DashboardLayout have the sidebar this button toggles
		hasDashboardNav: selectHasDashboardNav(state),
	}));

	let logoLink = '/';

	//this is because the root url is supposed to be a blank overview page,
	//if we want to redirect to it, we would need to clear out all the redux data for the current property
	// if (propertyData?.address) {
	// 	logoLink = `/property/${propertyData?.address}/overview`;
	// }

	return (
		<nav className="app-header violerts-v3-root tw-flex tw-items-center tw-justify-between tw-gap-4 tw-border-b tw-border-border-02 tw-bg-surface-layer-01 tw-px-6 tw-py-2">
			<div className="tw-flex tw-items-center tw-gap-2">
				{hasDashboardNav && (
					<button
						type="button"
						onClick={() => dispatch(toggleCollapseDashboardNav())}
						aria-label="Toggle sidebar"
						className="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-text-icon-primary hover:tw-bg-surface-layer-02"
					>
						<MenuIcon className="tw-h-4 tw-w-4" aria-hidden="true" />
					</button>
				)}
				<Link to={logoLink} className="tw-flex tw-items-center">
					<img
						src="/marketing/violerts-logo-01.png"
						className="tw-h-9 tw-w-auto"
						alt="Violerts"
					/>
				</Link>
			</div>

			<div className="tw-flex tw-items-center tw-gap-6">
				<HeaderSearch hideHeaderSearch={hideHeaderSearch} />
				<CartLink cartCount={cartCount} />
				<AccountDropdown />
			</div>
		</nav>
	);
};

export default AppHeader;
